import { z } from "zod";

export const userAccountSchema = z.object({
	contactEmail: z
		.string()
		.email("Invalid email address")
		.nullable()
		.refine((value) => value !== null && value !== "", {
			message: "Contact Email is required",
		}),
	contactAddress: z
		.string()
		.nullable()
		.refine((value) => value !== null && value !== "", {
			message: "Contact Address is required",
		}),
	contactPhone: z
		.string()
		.nullable()
		.refine((value) => value !== null && value !== "", {
			message: "Contact Phone is required",
		}),
	organizationAddress: z
		.string()
		.nullable()
		.refine((value) => value !== null && value !== "", {
			message: "Organization Address is required",
		}),
	organizationEmail: z
		.string()
		.email("Invalid email address")
		.nullable()
		.refine((value) => value !== null && value !== "", {
			message: "Organization Email is required",
		}),
	organizationName: z
		.string()
		.nullable()
		.refine((value) => value !== null && value !== "", {
			message: "Organization Name is required",
		}),
	organizationPosition: z
		.string()
		.nullable()
		.refine((value) => value !== null && value !== "", {
			message: "Organization Position is required",
		}),
	organizationTelephone: z
		.string()
		.nullable()
		.refine((value) => value !== null && value !== "", {
			message: "Organization Telephone is required",
		}),
});
